import template from './adpChartLegendItem.html';
import controller from './adpChartLegendItem.controller';
import './adpChartLegendItem.less';

let adpChartLegendItemComponent = {
  restrict: 'E',
  bindings: {
  	item: '<',
  },
  template,
  controller
};

export default adpChartLegendItemComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpChartLegendItem/adpChartLegendItem.component.js